import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { type CreditCardItemFormSchema } from '@webapp/modules/accounts-payable/components/CreditCardItemForm'
import { type CreditCardItem } from '@webapp/modules/accounts-payable/entities/CreditCardItem'
import messages from './messages'
import { useMutateUpdateCreditCardItem } from '../../models'

export interface IUseEditCreditCardItemFormPresenterParams {
  item: CreditCardItem
  mode: 'edit' | 'view'
  onSuccess: (item: CreditCardItem) => void
}

export const useEditCreditCardItemFormPresenter = ({
  item,
  mode,
  onSuccess,
}: IUseEditCreditCardItemFormPresenterParams) => {
  const intl = useProcurifyIntl()
  const { updateCreditCardItem, isUpdating } = useMutateUpdateCreditCardItem()

  const handleSubmit = async (schema: CreditCardItemFormSchema) => {
    try {
      const updated = await updateCreditCardItem({ item, mode, schema })

      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successMessage),
      })

      onSuccess(updated)
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(error) ??
          intl.formatMessage(messages.genericErrorMessage),
      })
    }
  }

  return {
    states: {
      isUpdating,
    },
    methods: {
      onSubmit: handleSubmit,
    },
  }
}
